import { useMutation } from '@tanstack/react-query'
import { graphqlRequest } from './graphql'

export interface ChangePasswordInput {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export interface ChangePasswordResult {
  success: boolean
  error?: string
}

/**
 * Change password using GraphQL mutation
 */
async function changePassword(input: ChangePasswordInput): Promise<ChangePasswordResult> {
  const { currentPassword, newPassword, confirmPassword } = input

  if (newPassword !== confirmPassword) {
    return { success: false, error: 'New passwords do not match' }
  }

  if (newPassword.length < 8) {
    return { success: false, error: 'Password must be at least 8 characters' }
  }

  try {
    const result = await graphqlRequest<{ changePassword: boolean }>(`
      mutation ChangePassword($input: ChangePasswordInput!) {
        changePassword(input: $input)
      }
    `, {
      input: {
        currentPassword,
        newPassword,
      },
    })

    if (result.errors?.length) {
      const errorMessage = result.errors[0].message
      return { success: false, error: errorMessage }
    }

    return { success: true }
  } catch (err) {
    return { 
      success: false, 
      error: err instanceof Error ? err.message : 'Network error' 
    }
  }
}

/**
 * Hook to change password
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: changePassword,
  })
}
